// src/App.tsx
import Home from './ui/pages/Home';
import BackgroundLayer from './ui/components/utils/BackgroundLayer';
// import ItemParticipant from './ui/components/items/Participan';
// import ItemRankingTop3 from './ui/components/items/ItemRankinTop3';
// import ItemRankingCustom from './ui/components/items/ItemRankinCustom';
import { SessionProvider } from './core/context/SessionContext';
import { DataProvider } from './core/context/DataContext';
import DataLoader from './ui/components/DataLoader';

function App() {
  const params = new URLSearchParams(window.location.search);
  const boxId = params.get('box_id') ?? '2';

  return (
    <DataProvider boxId={Number(boxId)}>
      <SessionProvider initialSessionId={boxId}>
        <BackgroundLayer>
          <DataLoader />
          <Home />
          {/* <>
      <div className="flex flex-col min-h-screen items-center justify-center gap-4">
        <ItemRankingTop3 img={'https://randomuser.me/api/portraits/men/32.jpg'} name={'Jorge R'} rating={'10'} position={1} />
        <ItemRankingCustom img={'https://randomuser.me/api/portraits/men/32.jpg'} name={'Jorge R'} rating={'10'} position={1} />
      </div>
      </> */}
        </BackgroundLayer>
      </SessionProvider>
    </DataProvider>
  );
}

export default App;
